import { useQuery } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getUserNotifications } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "./queryKeys";

export function useNotificationsQuery(offset = 0, limit = 50) {
  return useQuery({
    queryKey: NOTIFICATIONS_QUERY_KEYS.list(offset, limit),
    queryFn: processResponse(() => getUserNotifications(offset, limit)),
  });
}
